import loadable from '@loadable/component';
import { useLocalStorage } from '@schemeserve/global-utils';

export default !useLocalStorage().hasKey('ss_cookies_notif') &&
!useLocalStorage().getItem('ss_cookies_notif')
  ? loadable(
      () =>
        import(
          /* webpackChunkName: "cookies-bar " */
          // eslint-disable-next-line import/no-unresolved
          './App'
        ),

      { fallback: '' },
    )
  : () => null;
